import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const PageContentSC = styled.section`
  width: 100%;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: inset 0px 0px 0px 1px #eaeaea;
  background-color: #ffffff;

  @media (max-width: ${(props) => `${parseInt(props.theme.SizeBreakpointsS, 10) - 1}px`}) {
    padding: 1.5rem 1rem;
  }
`;

function PageContent({ className, children }) {
  return (
    <>
      <PageContentSC className={className}>{children}</PageContentSC>
    </>
  );
}

PageContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PageContent.defaultProps = {
  className: null,
};

export default PageContent;
